export const digitRegex = /\d/;
export const specialCharacterRegex =
  /[`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/;

export const singleSpaceSeparatorRegex = /^\S+( \S+)*$/;
